import classNames from 'classnames'
import { useTranslation } from 'next-i18next'
import React from 'react'

import { useQuinceRouter as useRouter } from '@src/modules/navigation'

import { Button, BUTTON_TYPES } from '../../atoms'

import styles from './errorScreen.module.scss'

interface ErrorScreenProps {
  title?: string
  description?: string
  onButtonClick?: () => void
}

const ErrorScreen = ({ title, description, onButtonClick }: ErrorScreenProps) => {
  const router = useRouter()
  const { t } = useTranslation('common')
  const navigateHome = () => {
    router.push('/')
  }
  return (
    <div className={styles.wrapper}>
      <div className={classNames(styles.contentContainer)}>
        <h3 className={classNames(styles.title)}>{title ?? t('it_s_not_you_it_s_us_v1')}</h3>
        <p className={classNames(styles.description, 'body2_grosa')}>{description ?? t('error_page_description')}</p>
        <Button type={BUTTON_TYPES.SECONDARY} className={styles.button} onClick={onButtonClick ?? navigateHome}>
          {t('go_back')}
        </Button>
      </div>
    </div>
  )
}

export default ErrorScreen
